module.exports = __webpack_public_path__ + "img/reel5.b42663ac.webp";